import * as utils from "./utils";
import EasyRedux from "./utils";
import history from "./history";

export {utils, history};
export default EasyRedux;